// @flow
import _ from "lodash"

import type { Price, Prices } from "../records/Price"
import type { RefundPaymentList } from "../records/RefundOption"

// expecting input with same currencies and positive fees (e.g. 20, not -20)
export const calculateRefundBeforeFeeDeductions = (
  priceAfterDeductions: Price,
  fee: ?Price,
  fee2: ?Price,
): Price => {
  let result = priceAfterDeductions.amount
  let resultAmountEur = priceAfterDeductions.amount_eur
  const { currency } = priceAfterDeductions

  if (priceAfterDeductions.amount === 0) {
    return {
      amount: 0,
      amount_eur: 0,
      currency,
    }
  }

  if (fee) {
    if (fee.currency !== currency) {
      throw new Error("Multiple currencies not supported")
    }
    result += fee.amount
    resultAmountEur += fee.amount_eur
  }

  if (fee2) {
    if (fee2.currency !== currency) {
      throw new Error("Multiple currencies not supported")
    }
    result += fee2.amount
    resultAmountEur += fee2.amount_eur
  }

  return {
    amount: result,
    amount_eur: resultAmountEur,
    currency,
  }
}

// expecting same currency
export const getTotalAmountFromPayments = (part: RefundPaymentList) =>
  part.reduce((acc, x) => acc + x.amount, 0)

export const hasNonRefundableFlights = (prices: Prices) =>
  _.some(prices, price => price.amount <= 0)
